import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';

function PaymentFail() {
	return (
		<Box>
			<Box
				textAlign='center'
				pb={4}
				style={{ borderBottom: '4px dotted #eee' }}
			>
				<img
					src='/images/fail.png'
					alt='check'
					width='60'
					style={{ marginBottom: '18px' }}
				/>
				<Typography variant='h6' gutterBottom>
					Transaction Declined
				</Typography>
			</Box>

			<Box display='flex' justifyContent='center' mt={6}>
				<RouterLink to='/'>
					<Link>
						<Button
							variant='contained'
							style={{ backgroundColor: '#1681EF', color: '#FFFFFF' }}
						>
							Go Back
						</Button>
					</Link>
				</RouterLink>
			</Box>
		</Box>
	);
}

export default PaymentFail;
